import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function EmptyState({ icon, title, description }) {
  return (
    <MDBox
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      py={10}
      px={3}
    >
      <MDBox
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="4rem"
        height="4rem"
        borderRadius="50%"
        bgColor="grey-200"
        mb={2}
      >
        <Icon fontSize="large" color="secondary">
          {icon}
        </Icon>
      </MDBox>
      <MDTypography variant="h6" fontWeight="medium" mb={0.5}>
        {title}
      </MDTypography>
      <MDTypography variant="button" color="text" fontWeight="regular">
        {description}
      </MDTypography>
    </MDBox>
  );
}

EmptyState.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default EmptyState;
